/**
 * AppointmentsCalendar — FASE 2: Vista mes/semana/día (usa toolbar nativo de react-big-calendar)
 */
import React, { useMemo, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { useTimezone } from "../../hooks/useTimezone";
import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/en-gb";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useStyles } from "./styles";
import AppointmentStatusBadge from "../../components/AppointmentStatusBadge";
import { i18n } from "../../translate/i18n";

const localizer = momentLocalizer(moment);

export default function AppointmentsCalendar({ appointments, onSelectEvent }) {
  // Estas fechas son HORA DE PARED de la empresa: no se convierten. Con `moment()` a
  // secas se leian en la zona del NAVEGADOR. Ver doc 0412 §11.
  const { parseHoraDePared } = useTimezone();
  const classes = useStyles();

  useEffect(() => {
    const lang = (i18n.language || "es").split("-")[0];
    if (lang === "en") moment.locale("en-gb");
    else if (lang === "pt") moment.locale("pt");
    else moment.locale("es");
  }, [i18n.language]);

  const messages = useMemo(
    () => ({
      date: i18n.t("appointmentsModule.calendar.date"),
      time: i18n.t("appointmentsModule.calendar.time"),
      event: i18n.t("appointmentsModule.calendar.event"),
      today: i18n.t("appointmentsModule.calendar.today"),
      previous: i18n.t("appointmentsModule.calendar.previous"),
      next: i18n.t("appointmentsModule.calendar.next"),
      month: i18n.t("appointmentsModule.calendar.month"),
      week: i18n.t("appointmentsModule.calendar.week"),
      day: i18n.t("appointmentsModule.calendar.day"),
      agenda: i18n.t("appointmentsModule.calendar.agenda"),
      noEventsInRange: i18n.t("appointmentsModule.calendar.noEventsInRange"),
    }),
    [i18n.language],
  );

  const events = (appointments || []).map((a) => ({
    id: a.id,
    title: `${a.contactName || i18n.t("appointmentsModule.calendar.noName")} - ${a.serviceName || i18n.t("appointmentsModule.calendar.serviceFallback")}`,
    start: new Date(a.appointmentDate),
    end: (parseHoraDePared(a.appointmentDate) || moment()).clone().add(a.durationMin || 60, "minutes").toDate(),
    resource: a,
  }));

  const EventComponent = ({ event }) => (
    <div className={classes.calendarEvent}>
      <strong>{event.title}</strong>
      <AppointmentStatusBadge status={event.resource?.status} />
    </div>
  );

  return (
    <div style={{ marginTop: 16 }}>
      <div className={classes.calendarWrap}>
        <Calendar
          key={i18n.language}
          culture={(i18n.language || "es").split("-")[0]}
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          messages={messages}
          onSelectEvent={onSelectEvent}
          components={{ event: EventComponent }}
          popup
        />
      </div>
    </div>
  );
}
